import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Grid, makeStyles, Hidden, Slide, Fade } from '@material-ui/core';
import PesquisarMembrosList from '../../components/Grupo/PesquisarMembrosList';
import MembroDetalhes from '../../components/Grupo/MembroDetalhes';
import { adicionarMembroAoGrupo } from '../../services/GruposApi';

export default function AdicionarMembro() {
    const [membro, setMembro] = React.useState(undefined);
    const [checked, setChecked] = React.useState(false);
    const history = useHistory();
    const { idGrupoPequeno, idIgreja } = useParams();

    const useStyles = makeStyles(theme => ({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(0),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
    }));
    const classes = useStyles();

    async function incluirNoMeuGrupo(e, membro) {
        try {
            const response = await adicionarMembroAoGrupo(
                membro.idAluno,
                idGrupoPequeno
            );
            setMembro(undefined);
            setChecked(prev => !prev);
            return response;
        } catch (error) {
            return null;
        }
    }

    const clickMembro = (e, membro) => {
        setMembro(membro);
        setChecked(prev => !prev);
    };

    const clickFechar = e => {
        setChecked(prev => !prev);
    };

    const clickCadastrarNovoMembro = e => {
        history.push(`/cadastrar_novo_membro/${idGrupoPequeno}/${idIgreja}`);
    };

    const handleIncluirNoMeuGrupo = async (e, membro) => {
        incluirNoMeuGrupo(e, membro);
    };
    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Hidden smUp>
                    <Fade
                        in={!checked}
                        style={{ display: checked ? 'none' : 'block' }}
                    >
                        <Grid item xs={12} sm={4}>
                            <PesquisarMembrosList
                                clickCadastrarNovoMembro={
                                    clickCadastrarNovoMembro
                                }
                                clickMembro={clickMembro}
                            />
                        </Grid>
                    </Fade>

                    <Slide
                        direction="left"
                        in={checked}
                        mountOnEnter
                        unmountOnExit
                    >
                        <Grid item xs={12}>
                            <MembroDetalhes
                                handleIncluirNoMeuGrupo={
                                    handleIncluirNoMeuGrupo
                                }
                                handleFechar={clickFechar}
                                membro={membro}
                            />
                        </Grid>
                    </Slide>
                </Hidden>
                <Hidden xsDown>
                    <Grid item xs={4}>
                        <PesquisarMembrosList
                            clickCadastrarNovoMembro={clickCadastrarNovoMembro}
                            clickMembro={clickMembro}
                        />
                    </Grid>

                    <Grid item xs={8}>
                        <MembroDetalhes
                            handleIncluirNoMeuGrupo={handleIncluirNoMeuGrupo}
                            handleFechar={clickFechar}
                            membro={membro}
                        />
                    </Grid>
                </Hidden>
            </Grid>
        </div>
    );
}
